
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useDashboardStore = create(
  persist(
    (set) => ({
      agents: [],
      totalCalls: 0,
      total_chat:0,
      hasFetched: false,
      // Pounce cards ka data ({ [agentId]: { plan, newLeads, callsMade,
      // bookedThisMonth } }). Agents ki tarah yahin rakha hai taaki dashboard
      // pe lautne par card turant purane numbers dikhaye, shimmer nahi.
      pounceSummary: {},
      // Pounce on/off ka aakhri pata haal (null = abhi pata nahi). Toggle isi se
      // turant sahi dikhta hai; server se taaza haal peeche se aata hai.
      pounceEnabled: null,

      setPounceEnabledCache: (pounceEnabled) => set({ pounceEnabled }),
      setPounceSummary: (pounceSummary) => set({ pounceSummary: pounceSummary || {} }),

      // ✅ Set dashboardcxcxc data and mark as fetched
      setDashboardData: (agents, totalCalls,total_chat) =>
        set({ agents, totalCalls, total_chat,hasFetched: true }),

      // ✅ Set hasFetched manually
      setHasFetched: (value) => set({ hasFetched: value }),

      // ✅ Reset the store completely
      reset: () =>
        set({
          agents: [],
          totalCalls: 0,
          hasFetched: false,
          total_chat:0,
          pounceSummary: {},
          pounceEnabled: null,

        }),
    }),
    {
      name: 'dashboard-session-storage',

      // ✅ Only persist actual data (not runtime flags like hasFetched)
      partialize: (state) => ({
        agents: state.agents,
        totalCalls: state.totalCalls,
        total_chat:state.total_chat,
        pounceSummary: state.pounceSummary,
        pounceEnabled: state.pounceEnabled,
      }),

      // ✅ Use sessionStorage (not localStorage)
      storage: {
        getItem: (name) => {
          const value = sessionStorage.getItem(name);
          return value ? JSON.parse(value) : null;
        },
        setItem: (name, value) => {
          sessionStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: (name) => {
          sessionStorage.removeItem(name);
        },
      },
    }
  )
);
